import ycn from './ycn/routes';
import ycp from './ycp/routes';
import ycv from './ycv/routes';
import ymk from './ymk/routes';
//import y4b from './y4b/routes';
import yca from './yca/routes';
import dynamicapps from './dynamicapps/routes';

export default [ycn, ycp, ycv, ymk, yca, dynamicapps /*, y4b*/];
